import type {
  NumberInputFieldProps,
  NumberInputProps} from '@chakra-ui/react'
import {
  InputGroup,
  InputRightElement,
  NumberInput,
  NumberInputField
} from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'

interface CustomNumberInputProps extends Omit<NumberInputProps, 'defaultValue'> {
  onValueChange?: (value: string, valueAsNumber?: number) => void
  defaultValue?: number | undefined | null
  inputRightElement?: string | React.ReactNode | null
  inputProps?: NumberInputFieldProps
}

export const CustomNumberInput = React.forwardRef(({
  onValueChange,
  defaultValue,
  inputRightElement = 'Kč',
  inputProps,
  ...rest
}: CustomNumberInputProps, ref
) => {
  const [value, setValue] = useState(defaultValue)
  const format = (val: number | undefined) => val !== undefined ? new Intl.NumberFormat('cs-CZ').format(Number(val)) : ''
  const parse = (val: number | undefined) => val !== undefined ? String(val).replace(/ /, '') : ''

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  return (
    <InputGroup>
      <NumberInput
        ref={ref}
        value={format(value ?? undefined)}
        // defaultValue={format(value)}
        focusInputOnChange={false}
        onChange={(valueAsString: string, valueAsNumber: number) => {
          const val = isNaN(valueAsNumber) ? undefined : valueAsNumber
          setValue(val)
          onValueChange?.(val ? parse(val) : '', val)
        }}
        {...rest}
      >
        <NumberInputField maxW={128} minW='100%' {...inputProps} />

        {inputRightElement && <InputRightElement>{inputRightElement}</InputRightElement>}
      </NumberInput>
    </InputGroup>
  )
}
)